import ExitToApp from "@material-ui/icons/ExitToApp";

import Table from "src/components/Table";
import { listSubaccounts_listSubaccounts } from "src/graphql/generated/listSubaccounts";

export default function SubaccountTable({
  rows,
  page,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  totalCount
}: {
  rows: listSubaccounts_listSubaccounts[];
  page: number;
  handleChangePage: (newPage: number) => void;
  rowsPerPage: number;
  handleChangeRowsPerPage: (newRowsPerPage: number) => void;
  totalCount: number;
}): JSX.Element {
  return (
    <Table
      columns={[
        {
          key: "name",
          title: "Name",
          renderValue: subaccount => subaccount.name
        },
        {
          key: "createdAt",
          title: "Created At",
          renderValue: subaccount =>
            new Date(subaccount.createdAt).toLocaleString()
        }
      ]}
      rows={rows}
      rowActions={[
        {
          type: "link",
          icon: <ExitToApp />,
          tooltipLabel: "Go To Subaccount",
          href: subaccount => `/subaccounts/${subaccount.id}/campaigns`
        }
      ]}
      emptyState="No subaccounts found"
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      page={page}
      onChangePage={handleChangePage}
    />
  );
}
